"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PipeGenerator_normalRoom = void 0;
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
const PointLocator_js_1 = __importDefault(require("jsts/org/locationtech/jts/algorithm/PointLocator.js"));
const Location_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Location.js"));
const pipeCommonUtil_1 = require("./util/pipeCommonUtil");
const boundingBox_1 = require("../boundingBox");
const pipeNodeGroup_1 = require("./pipeNodeGroup");
const pipeNode_1 = require("./pipeNode");
const pipeResultV2_1 = require("./pipeResultV2");
const mainDirectionUtil_1 = require("./util/mainDirectionUtil");
const sprinklerSpacing_1 = require("./room/sprinklerSpacing");
class PipeGenerator_normalRoom {
    generate_V2(points, doors_belongHere, radius, minDisToWall, mainPipes, polygonSegs, polygon) {
        let directionResult = new mainDirectionUtil_1.MainDirectionUtil().compute(points, doors_belongHere, mainPipes, polygonSegs);
        let coordinateUtil = directionResult.coordinateUtil;
        let points_local = new Array();
        for (let point of points) {
            let point_local = coordinateUtil.transformPointToLocal(point);
            points_local.push(new Coordinate_js_1.default(point_local.x, point_local.y));
        }
        let boundingBox = new boundingBox_1.BoundingBox(points_local);
        let lengthX = boundingBox.getLengthX();
        let lengthY = boundingBox.getLengthY();
        let nearestMainPipe_local = coordinateUtil.transformLineSegmentToLocal(directionResult.nearestMainPipe);
        let spacingInfo = new sprinklerSpacing_1.SprinklerSpacing().compute(lengthX, lengthY, radius);
        let blankDis_x = spacingInfo[0];
        let blankDis_y = spacingInfo[1];
        //计算X坐标
        let xArr = pipeCommonUtil_1.PipeCommonUtil.computeCoordArrV2(lengthX, boundingBox.min.x, boundingBox.max.x, blankDis_x);
        //计算Y坐标
        let yArr = pipeCommonUtil_1.PipeCommonUtil.computeCoordArrV2(lengthY, boundingBox.min.y, boundingBox.max.y, blankDis_y);
        //多边形的边也转到局部坐标系下
        let polygonSegs_local = coordinateUtil.transformLineSegmentArrayToLocal(polygonSegs);
        let polygon_local = coordinateUtil.transformPolygonToLocal(polygon);
        //分区域布设管点，一个区域一个group
        let pipeNodeGroups = new Array();
        if (xArr.length <= 16) {
            let pipeNodeGroup = this.computePipeGroup(xArr, yArr, nearestMainPipe_local, polygonSegs_local, blankDis_x, minDisToWall, polygon_local);
            if (pipeNodeGroup)
                pipeNodeGroups.push(pipeNodeGroup);
        }
        else {
            let groupCount = Math.ceil(xArr.length / 16);
            let numEachGroup = Math.floor(xArr.length / groupCount); //这里用floor和ceil都可以
            for (let i = 0; i < groupCount; i++) {
                let startIndex = i * numEachGroup;
                let endIndex = startIndex + numEachGroup > xArr.length ? xArr.length : startIndex + numEachGroup;
                let pipeNodeGroup = this.computePipeGroup(xArr.slice(startIndex, endIndex), yArr, nearestMainPipe_local, polygonSegs_local, blankDis_x, minDisToWall, polygon_local);
                if (pipeNodeGroup)
                    pipeNodeGroups.push(pipeNodeGroup);
            }
        }
        if (pipeNodeGroups.length == 0) {
            return null;
        }
        let pipeResult = this.convertPipeNodeGroupsToResult_room(pipeNodeGroups, coordinateUtil);
        pipeResult._polygonSegsLocal = polygonSegs_local;
        return pipeResult;
    }
    computeMainPipeX(xArr) {
        let minX = xArr[0];
        let maxX = xArr[xArr.length - 1];
        let centerX = (minX + maxX) / 2;
        let mainPipeX = centerX;
        if (xArr.length == 1) {
            mainPipeX += 600; //为了主管线不距离管点太近所设置的经验值
        }
        else { //直接用centerX有可能会跟某列点重合，向左偏移一段，移到左边那段管线的中点
            for (let i = 0; i < xArr.length; i++) {
                if (Math.abs(xArr[i] - mainPipeX) < 100) { //这里容差设为100是因为计算管点坐标时有可能会左移右移50，有可能造成100的偏差
                    mainPipeX = (xArr[i] + xArr[i - 1]) / 2;
                    break;
                }
            }
        }
        return mainPipeX;
    }
    computePipeGroup(partOfXArr, yArr, nearestMainPipe, polygonSegs_local, blankDis, minDisToWall, polygon_local) {
        let mainPipeX = this.computeMainPipeX(partOfXArr);
        //将y数组调成距离主管道从近到远的顺序
        if (nearestMainPipe.distance(new Coordinate_js_1.default(mainPipeX, yArr[0])) > nearestMainPipe.distance(new Coordinate_js_1.default(mainPipeX, yArr[yArr.length - 1]))) {
            yArr.reverse();
        }
        //要不只针对异形房间？先遍历一遍，如果有其中一个点(mainPipeX,y)不在房间内，则判断为异形房间，每行的主节点的X单独计算
        let isSpecialRoom = false;
        let pointLocator = new PointLocator_js_1.default();
        for (let y of yArr) {
            if (pointLocator.locateInPolygon(new Coordinate_js_1.default(mainPipeX, y), polygon_local) !== Location_js_1.default.INTERIOR) {
                isSpecialRoom = true;
                break;
            }
        }
        //从距离主管道近的一侧开始
        //先构建主管道节点
        let mainPipeNodes = new Array();
        let childPipeNodes = new Array();
        for (let i = 0; i < yArr.length; i++) {
            let y = yArr[i];
            //调整X数组
            let adjustXArr = pipeCommonUtil_1.PipeCommonUtil.adJustChildPipePoints(polygonSegs_local, partOfXArr, y, blankDis, minDisToWall, polygon_local);
            if (adjustXArr.length == 0) { //调整后可能会整行都不在多边形内，所以可能会有空数组
                continue;
            }
            let mainPipeNode;
            //TODO：这里好像得判断一下这个主节点在不在多边形内
            //如果该行的主节点不在多边形内，则要调整（如果调整了也不行呢）
            if (isSpecialRoom) {
                let rowMainPipeX = this.computeMainPipeX(adjustXArr);
                if (Math.abs(rowMainPipeX - mainPipeX) < 100) { //这里的100阈值是随便给的
                    mainPipeNode = new pipeNode_1.PipeNode(new Coordinate_js_1.default(mainPipeX, y), pipeNode_1.PipeNodeType.Main);
                }
                else {
                    mainPipeNode = new pipeNode_1.PipeNode(new Coordinate_js_1.default(rowMainPipeX, y), pipeNode_1.PipeNodeType.Main);
                }
            }
            else {
                mainPipeNode = new pipeNode_1.PipeNode(new Coordinate_js_1.default(mainPipeX, y), pipeNode_1.PipeNodeType.Main);
            }
            if (i > 0 && mainPipeNodes.length > 0) {
                let previousNode = mainPipeNodes[mainPipeNodes.length - 1];
                if (previousNode._point.x === mainPipeNode._point.x) {
                    previousNode.addChildNode(mainPipeNode);
                }
                else {
                    let previousNode = mainPipeNodes[mainPipeNodes.length - 1];
                    let linkY = (previousNode._point.y + mainPipeNode._point.y) / 2;
                    let linkNode1 = new pipeNode_1.PipeNode(new Coordinate_js_1.default(previousNode._point.x, linkY), pipeNode_1.PipeNodeType.Main);
                    let linkNode2 = new pipeNode_1.PipeNode(new Coordinate_js_1.default(mainPipeNode._point.x, linkY), pipeNode_1.PipeNodeType.Main);
                    previousNode.addChildNode(linkNode1);
                    linkNode1.addChildNode(linkNode2);
                    linkNode2.addChildNode(mainPipeNode);
                    mainPipeNodes.push(linkNode1);
                    mainPipeNodes.push(linkNode2);
                }
            }
            mainPipeNodes.push(mainPipeNode);
            //构建子管道节点
            //子管道节点是从远端开始的
            let childPipeNodes_left = new Array();
            for (let j = 0; adjustXArr[j] < mainPipeX; j++) {
                let x = adjustXArr[j];
                let node = new pipeNode_1.PipeNode(new Coordinate_js_1.default(x, y), pipeNode_1.PipeNodeType.Child);
                if (j > 0) {
                    node.addChildNode(childPipeNodes_left[childPipeNodes_left.length - 1]);
                }
                childPipeNodes_left.push(node);
            }
            //子管点连接上主管点
            if (childPipeNodes_left.length > 0)
                mainPipeNode.addChildNode(childPipeNodes_left[childPipeNodes_left.length - 1]);
            //从另一头最远端开始
            let childPipeNodes_right = new Array();
            for (let j = adjustXArr.length - 1; adjustXArr[j] > mainPipeX; j--) {
                let x = adjustXArr[j];
                let node = new pipeNode_1.PipeNode(new Coordinate_js_1.default(x, y), pipeNode_1.PipeNodeType.Child);
                if (j < adjustXArr.length - 1) {
                    node.addChildNode(childPipeNodes_right[childPipeNodes_right.length - 1]);
                }
                childPipeNodes_right.push(node);
            }
            if (childPipeNodes_right.length > 0)
                mainPipeNode.addChildNode(childPipeNodes_right[childPipeNodes_right.length - 1]);
            childPipeNodes = childPipeNodes.concat(childPipeNodes_left).concat(childPipeNodes_right);
        }
        if (mainPipeNodes.length == 0)
            return null;
        return new pipeNodeGroup_1.PipeNodeGroup(mainPipeNodes, childPipeNodes);
    }
    convertPipeNodeGroupsToResult_room(pipeNodeGroups, coordinateUtil) {
        //转换到全局坐标
        for (let pipeNodeGroup of pipeNodeGroups) {
            for (let node of pipeNodeGroup._mainPipeNodes) {
                node._point = coordinateUtil.transformPointToWorld(node._point);
            }
            for (let node of pipeNodeGroup._childPipeNodes) {
                node._point = coordinateUtil.transformPointToWorld(node._point);
            }
        }
        let pipeResult = new pipeResultV2_1.PipeResultV2(pipeNodeGroups, coordinateUtil);
        return pipeResult;
    }
}
exports.PipeGenerator_normalRoom = PipeGenerator_normalRoom;
